import React from 'react';
import { MISSION_COUNTRIES, missionCountry } from '../utils/missionCountries';

/** Country for the missions payload. A session also shows its ordinal in the event. */
export default function MissionReportFields({ scopeId, country, sessionNumber, disabled, onChange }) {
  return (
    <div className="custom-reports-flag-row">
      <label className="custom-reports-field" htmlFor={`custom-report-country-${scopeId}`}>
        <span>Country</span>
        <select
          id={`custom-report-country-${scopeId}`}
          className="custom-reports-control"
          value={missionCountry(country)}
          onChange={(e) => onChange({ country: e.target.value })}
          disabled={disabled}
        >
          <option value="">Select a country</option>
          {MISSION_COUNTRIES.map((name) => <option key={name} value={name}>{name}</option>)}
        </select>
      </label>
      {sessionNumber != null && (
        <label className="custom-reports-field custom-reports-field-day">
          <span>Session</span>
          <input className="custom-reports-control" value={sessionNumber} readOnly />
        </label>
      )}
    </div>
  );
}
